import { useState } from "react";
import { toast } from "sonner";
import { Mic, Upload } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export const PodcastSubmitDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", title: "", description: "" });
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!file) return toast.error("Sélectionnez un fichier audio.");
    setLoading(true);
    const fd = new FormData();
    Object.entries(form).forEach(([k, v]) => fd.append(k, v));
    fd.append("file", file);
    try {
      await api.post("/podcasts/submissions", fd);
      toast.success("Audio déposé ! La rédaction l'examinera avant publication.");
      setOpen(false); setForm({ name: "", email: "", title: "", description: "" }); setFile(null);
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <>
      <Button data-testid="podcast-upload-button" onClick={() => setOpen(true)} className="bg-red-600 hover:bg-red-700 rounded-none font-bold uppercase text-xs tracking-wider h-11 px-5"><Mic size={16} className="mr-2" /> Déposer un audio</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg rounded-none" data-testid="podcast-upload-dialog">
          <DialogHeader><DialogTitle className="font-heading text-xl font-black">Déposer un audio</DialogTitle><DialogDescription>Proposez votre chronique, témoignage ou reportage sonore. Formats : MP3, WAV, M4A, OGG (60 Mo max).</DialogDescription></DialogHeader>
          <form onSubmit={submit} className="space-y-3">
            <div className="grid sm:grid-cols-2 gap-3">
              <Input data-testid="podcast-submit-name" required placeholder="Votre nom *" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              <Input data-testid="podcast-submit-email" type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
            </div>
            <Input data-testid="podcast-submit-title" required placeholder="Titre de l'audio *" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
            <Textarea data-testid="podcast-submit-description" rows={3} placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
            <label className="flex items-center gap-3 border-2 border-dashed border-zinc-300 p-4 cursor-pointer hover:border-red-600 transition-colors">
              <Upload size={18} className="text-red-600" />
              <span className="text-sm text-zinc-600 truncate">{file ? file.name : "Choisir un fichier audio…"}</span>
              <input data-testid="podcast-submit-file" type="file" accept="audio/*" className="hidden" onChange={(e) => setFile(e.target.files[0])} />
            </label>
            <Button data-testid="podcast-submit-btn" disabled={loading} className="w-full bg-red-600 hover:bg-red-700 rounded-none font-bold uppercase text-xs tracking-wider">{loading ? "Envoi en cours…" : "Envoyer"}</Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
